export const config = {
  usHost: import.meta.env.VITE_US_HOST,
  apiUrl: import.meta.env.VITE_API_URL,
  isDev: import.meta.env.VITE_DEV || false,
  getDomain: () => {
    return config.isDev ? import.meta.env.VITE_DEV_DOMAIN : window.location.hostname;
  },
  isUs: () => {
    return config.getDomain().includes(import.meta.env.VITE_US_HOST);
  },
  isUk: () => {
    return config.getDomain().includes(import.meta.env.VITE_UK_HOST);
  },
  adminUrl: import.meta.env.VITE_ADMIN_URL,
  adminUkUrl: import.meta.env.VITE_ADMIN_UK_URL,
  getAdminUrl: (url: string) => {
    if (config.isUk()) {
      return `${config.adminUkUrl}${url}`;
    } else {
      return `${config.adminUrl}${url}`;
    }
  },

  getApiUrl(url: string) {
    return `${config.apiUrl}${url}`;
  },
};